<template>
  <form action="false" @submit.prevent="onSave">
    <div class="modal_inputs">
      <Datepicker
        :id="DATES"
        v-model="formData[DATES]"
        :inputAttrs="{ name: DATES }"
        :timeConfig="{ enableTimePicker: false }"
        label="Created from/to:"
        range
      />
      <Multiselect
        :id="STATUS_FILTER"
        v-model="formData[STATUS_FILTER]"
        :closeOnSelect="false"
        :name="STATUS_FILTER"
        :options="prettyPreviewStatusOptions"
        placeholder="Status"
        mode="tags"
        searchable
        :classes="{
          tag: 'bg-hqPurple300 text-hqPurple rounded-sm flex p-1 pl-2 mb-1 mr-1 text-sm',
        }"
      />
      <Multiselect
        v-model="formData[AGENT_TYPE]"
        :name="AGENT_TYPE"
        :options="agentTypeOptions"
        placeholder="Select agent type"
      />
      <FormKit
        v-model="formData[ACTIVE_ONLY]"
        :name="ACTIVE_ONLY"
        label="Show Only Active"
        type="checkbox"
      />
    </div>
    <div class="modal_actions">
      <Button secondaryButton text="Clear" @click="onClear" />
      <Button text="Apply" type="submit" />
    </div>
  </form>
</template>
<script setup>
import { usePreviewRequestsFilters } from "@/components/UI/Modal/Bodies/PreviewRequestsFilters/PreviewRequestsFilters.hook";
import Button from "@/components/UI/Form/Button/Button.vue";
import Datepicker from "@/components/UI/Form/Datepicker/Datepicker.vue";
import Multiselect from "@/components/UI/Form/Multiselect/Multiselect.vue";
import { DATES, STATUS_FILTER, AGENT_TYPE, ACTIVE_ONLY } from "./PreviewRequestsFilters.consts";

const { formData, onSave, onClear, prettyPreviewStatusOptions, agentTypeOptions } =
  usePreviewRequestsFilters();
</script>
